import { render, staticRenderFns } from "./SubmitQueryModal.vue?vue&type=template&id=60621406&"
import script from "./SubmitQueryModal.vue?vue&type=script&lang=js&"
export * from "./SubmitQueryModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitQueryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports